import { App } from 'vue'
import vLoading from './loading'

// 注册全局指令
export function setupDirectives(app: App) {
  app.directive('loading', vLoading)
}

// 导出单个指令，方便按需使用
export { vLoading }
